<!--<button class="btn btn-primary" [routerLink]="'home'">LOGIN</button>-->
<div class="d-flex flex-column min-vh-100">
	<app-header-new></app-header-new>

	<router-outlet></router-outlet>

	<div class="mt-auto">
		<app-footer-new></app-footer-new>
	</div>
</div>